import { RECEIVE_LIQUORS } from './types';
import { showLoading, hideLoading } from 'react-redux-loading-bar';

const receiveLiquors = (data, ids) => {
    return {
        type: RECEIVE_LIQUORS,
        payload: data,
        ids: ids,
    };
};
export const fetchLiquors = () => async (dispatch) => {
    dispatch(showLoading());
    if (process.env.NODE_ENV === 'development') {
        const json = require('../products.json');
        dispatch(receiveLiquors(json.byId, json.ids));
        dispatch(hideLoading());
    } else {
        fetch(
            'https://firebasestorage.googleapis.com/v0/b/windsor-liquor.appspot.com/o/products.json?alt=media&token=7f77b08c-6d95-4fc3-b764-2d60be4ca31d',
            {
                method: 'GET',
            }
        )
            .then((res) => res.json())
            .then((json) => {
                dispatch(receiveLiquors(json.byId, json.ids));
                dispatch(hideLoading());
            });
    }
    // liquors.get().then(async (snapshot) => {
    // var liquors = {};
    // var ids = [];
    // for (let doc of snapshot.docs) {
    //     const data = doc.data();
    //     liquors[doc.id] = { id: doc.id, ...data };
    //     ids.push(doc.id);
    // }
    // dispatch(receiveLiquors(liquors, ids));
    //     dispatch(hideLoading());
    // });
};
